export const notificationLogs = {
  name: '通知日誌 |||| 通知日誌',
  fields: {
    id: 'ID',
    type: '類型',
    recipient_id: '收件人 ID',
    recipient_type: '收件人類型',
    recipient: '收件人',
    channel: '頻道',
    status: '狀態',
    template: '模板',
    language: '語言',
    data: '數據',
    error: '錯誤',
    retry_count: '重試次數',
    sent_at: '發送時間',
    delivered_at: '送達時間',
    created_at: '建立時間',
    actions: '操作',
    notification: '通知',
    details: '詳情',
  },
  list: {
    title: '通知日誌',
    empty: '沒有找到通知日誌',
    filters: {
      search: '搜尋 ID、模板或類型',
      status: '狀態',
      channel: '頻道',
      recipient_type: '收件人類型',
      type: '通知類型',
      startDate: '開始日期',
      endDate: '結束日期',
    },
  },
  show: {
    title: '通知日誌詳情',
    tabs: {
      details: '詳情',
      data: '數據',
      error: '錯誤',
    },
    sections: {
      status: '狀態資訊',
      recipient: '收件人資訊',
      timestamps: '時間戳記',
      error: '錯誤資訊',
      data: '通知數據',
    },
  },
  actions: {
    retry: '重試',
    export: '匯出',
    view_details: '查看詳情',
  },
  status: {
    queued: '排隊中',
    sending: '發送中',
    sent: '已發送',
    delivered: '已送達',
    failed: '失敗',
    bounced: '退回',
  },
  channels: {
    email: '電子郵件',
    sms: '簡訊',
    whatsapp: 'WhatsApp',
    push: '推送通知',
    slack: 'Slack',
  },
  recipient_types: {
    app_user: '應用程式用戶',
    backend_user: '後台用戶',
    external: '外部',
  },
  messages: {
    retry_success: '通知已排隊重試',
    retry_error: '重試通知失敗',
    export_success: '日誌匯出成功',
    export_error: '匯出日誌失敗',
  },
  permissions: {
    no_access: '您沒有權限查看通知日誌',
    read_only: '您只有通知日誌的唯讀權限',
  },
  details: {
    noDetails: '沒有可用的詳情',
    retries: '%{count} 次重試',
  },
};